import { useState } from "react";
import Particless from "./Prodution_Particless";
import pro from "../../../images/production.gif";

const StableDiffusion = () => {
  const [prompt, setPrompt] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const generateImage = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "http://72.109.215.3:7860/sdapi/v1/txt2img",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ prompt, steps: 20 }),
        }
      );
      const data = await response.json();
      if (data.images && data.images.length > 0) {
        const base64Image = data.images[0];
        const imageUrl = `data:image/png;base64,${base64Image}`;
        setImageUrl(imageUrl);
      }
    } catch (error) {
      console.error("Error generating image:", error);
    } finally {
      setLoading(false);
    }
  };

  const downloadImage = () => {
    if (!imageUrl) return;
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = "generated_image.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="h-screen w-full items-center card bg-black ">
      <Particless />

      <img src={pro} className="h-64"/>

      <div className=" z-10   ">

        
        <input

        className="w-96"
          type="text"
          placeholder="Enter prompt..."
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
        <button onClick={generateImage} disabled={loading}>
          {loading ? "Generating..." : "Generate Image"}
        </button>
        {imageUrl && (
          <div>
            <img src={imageUrl} alt="Generated" style={{ width: "300px" }} />
            <button onClick={downloadImage}>Download</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default StableDiffusion;
